import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import Header from "../components/Header";
import Footer from "../components/Footer";
import NewsletterStrip from "../components/NewsletterStrip";
import VideoBlogSection from "../components/VideoBlogSection";

export default function DestinationPage() {
  const { slug } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/destinations/slug/${slug}`).then((r) => setD(r.data)).catch(() => {}); }, [slug]);
  if (!d) return (<div className="min-h-screen"><Header /><div className="container-page py-24">Loading…</div></div>);
  const sections = [
    ["Best Time to Visit", d.best_time_to_visit],
    ["How to Get There", d.how_to_get_there],
    ["Where to Stay", d.where_to_stay],
    ["Points Strategy", d.points_strategy],
    ["Local Transport", d.local_transport],
    ["Budget Tips", d.budget_tips],
    ["Safety Notes", d.safety_notes],
  ].filter(([, v]) => v);
  return (
    <div className="min-h-screen bg-[#F9F9F6]">
      <Header />
      <div className="relative h-[60vh] overflow-hidden" data-testid="destination-hero">
        {d.hero_image && <img src={d.hero_image} alt={d.destination_name} className="absolute inset-0 w-full h-full object-cover" />}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
        <div className="relative container-page h-full flex flex-col justify-end pb-10 text-white">
          <Link to="/destinations" className="overline text-[#D6CFC4]">← All destinations</Link>
          <div className="overline mt-4 text-[#D6CFC4]">{d.country}</div>
          <h1 className="font-serif text-5xl md:text-7xl tracking-tight mt-2">{d.destination_name}</h1>
        </div>
      </div>
      <article className="container-page py-16 max-w-4xl">
        <p className="font-serif text-2xl leading-snug text-[#1C1A17]">{d.intro}</p>
        <div className="mt-12 space-y-10">
          {sections.map(([k, v]) => (
            <div key={k}>
              <div className="overline text-[#B4533C] mb-2">{k}</div>
              <p className="text-[#1C1A17] leading-relaxed">{v}</p>
            </div>
          ))}
        </div>
      </article>
      <div className="container-page">
        <VideoBlogSection variant="inline" tag={d.destination_name?.split(",")[0]} heading={`On film: ${d.destination_name}`} eyebrow="Destination video blog" />
      </div>
      <NewsletterStrip />
      <Footer />
    </div>
  );
}
